<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.26976 12.404L7.99958 12.2305L7.7294 12.404L3.81305 14.9191L4.88696 10.1847L4.95182 9.89876L4.73397 9.70255L1.19266 6.51296L5.81664 6.12344L6.12559 6.09742L6.23963 5.80911L7.99958 1.35943L9.75953 5.80911L9.87357 6.09742L10.1825 6.12344L14.8072 6.51296L11.2652 9.70252L11.0473 9.89873L11.1122 10.1847L12.1861 14.9191L8.26976 12.404Z" :fill="color" :stroke="strokeColor"/>
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class WcIconStar extends Vue {
  @Prop({ default: '#5138EE' }) color!: string
  @Prop({ default: 'rgba(4, 4, 16, 0.87)' }) strokeColor!: string
  @Prop({ default: '16' }) height!: string
  @Prop({ default: '16' }) width!: string
}
</script>

<style scoped>

</style>
